<template>
  <section class="loginReg" :style="{ '--panelColor': panelColor, '--labelColor': labelColor, '--minWidth': minWidth, '--boxShadow': boxShadow }">
    <div class="loginReg-header-container">
      <div v-html="accessConfig.headerLogo"></div>
    </div>
    <div class="loginReg-container">
      <img class="loginReg-background-img" :src="accessConfig.registerView.bg" />
      <video class="loginReg-background-img" playsinline autoplay muted :loop="accessConfig.registerView.loopBGVideo" id="bgvideo" :poster="accessConfig.registerView.bg" v-if="accessConfig.registerView.bg">
        <source :src="accessConfig.registerView.bgVideo" type="video/mp4" v-if="accessConfig.registerView.bgVideo" />
      </video>
      <div class="loginReg-first-container" v-if="accessConfig.registerView.position == 'right'">
        <transition appear name="translate">
          <div class="loginReg-eventLogo" v-html="accessConfig.registerView.eventLogo"></div>
        </transition>
      </div>
      <div class="register-second-container">
        <div class="register-title" v-html="accessConfig.registerView.accessContainer"></div>
        <div class="register-inputs-wrapper">
          <FormInputs ref="formInputs" :fieldGroups="fieldGroups" :autoLogin="accessConfig.registerView.autoLogin" v-if="accessConfig.publicSignIn" />
          <!-- ROUTES -->
          <div style="margin: 0 0 20px 0" v-if="!accessConfig.publicSignIn && accessConfig.registerView.inactiveRegisterHtml" v-html="accessConfig.registerView.inactiveRegisterHtml"></div>
          <div class="bottom-instructions" v-if="accessConfig.registerView.signInText || accessConfig.registerView.outLink">
            <router-link class="bottom-route" :to="{ name: 'Login' }" v-html="accessConfig.registerView.signInText"></router-link>
            <br />
            <a class="bottom-out-link" :href="accessConfig.registerView.outLink" target="_blank" v-html="accessConfig.registerView.outText"></a>
          </div>
          <div v-if="accessConfig.registerView.bottomHtml" v-html="accessConfig.registerView.bottomHtml"></div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import Footer from '@/components/general/Footer.vue';
import { VueTelInput } from 'vue-tel-input';
import FormInputs from '@/components/general/FormInputs.vue';

let resetUser = false;

export default {
  name: 'Register',
  components: { Footer, VueTelInput, FormInputs },

  data() {
    return {
      accessConfig: {},
      panelColor: 'transparent',
      labelColor: '#FFFFFF',
      minWidth: 'auto',
      boxShadow: '0px 0px 40px 0 rgba(0, 0, 0, 0.0)',
    };
  },
  watch: {
    $route() {
      this.accessConfig = this.$store.state.template.accessConfig;
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log('ROUTE', from.name, to.name);
    // console.log(from.name);

    next((vm) => {
      vm.prevRoute = from;
      // console.log('vm.prevRoute', vm.prevRoute);
      if (vm.prevRoute.name == 'Home' || vm.prevRoute.name == 'Login' || vm.prevRoute.name == 'LandingPage') {
        resetUser = true;
        // console.log('reset user: ', resetUser);
      }
    });
  },

  beforeMount() {
    if (this.$store.state.template.useUnifiedLoginRegister) {
      window.location.reload();
      return;
    }
    this.accessConfig = this.$store.state.template.accessConfig;
    if (this.accessConfig.registerView.autoLogin) {
      resetUser = true;
    }
    // ORDERING INPUT FIELDS ARRAY
    this.fieldGroups = this.accessConfig.registerView.fieldGroups.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    this.fieldGroups.map((group) => {
      group.fields.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    });

    // CONDITIONS TO LOWER CASE
    this.fieldGroups.map((group) => {
      group.fields.map((field) => {
        if (field.conditional)
          field.conditional.map((item) => {
            item.condition = item.condition.map((cond) => {
              cond = cond.toLowerCase();
              // console.log('CONDITION inregister: ', cond);
              return cond;
            });
          });
      });
    });

    // SET PANEL COLOR TO ADMIN JSON ONLY IF IT EXISTS, ELSE IT´S TRANSPARENT
    if (this.accessConfig.registerView.panelColor) this.panelColor = this.accessConfig.registerView.panelColor;
    if (this.accessConfig.registerView.labelColor) this.labelColor = this.accessConfig.registerView.labelColor;
    this.minWidth = this.accessConfig.registerView.minWidth;

    // LANGUAGES
    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';

    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
    }
  },
  mounted() {
    if (resetUser) {
      this.$store.commit('resetUser');
      // this.$router.go();
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.register-second-container {
  min-width: var(--minWidth) !important;
  margin: 4% 6% 10%;
  height: 100%;
  z-index: 1;
  border: 1px solid var(--input-panelBorderColor);
  border-radius: var(--input-borderRadius);
  box-shadow: var(--boxShadow);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.register-inputs-wrapper {
  display: flex;
  flex-direction: column;
  padding: 4%;
  background-color: var(--panelColor);
  border-bottom-right-radius: var(--input-borderRadius);
  border-bottom-left-radius: var(--input-borderRadius);
  width: 100%;
}
.register-title {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: var(--text-color);
}
.inputs-group-box {
  margin: var(--group-margin);
  padding: var(--group-padding);
  border-radius: var(--group-borderRadius);
}
.inputs-line-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  gap: 20px;
}
.general-input-container {
  width: 100%;
  margin-top: 1%;
}
.general-input-wrapper {
  position: relative;
  margin: 1% 0;
  display: flex;
  align-items: center;
  min-height: 38px;
  min-width: 20%;
  width: 100%;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--input-borderRadius);
}
.ionicon-icon {
  font-size: 22px;
  min-width: 20px;
  padding: 10px;
  padding-right: 2px;
  color: var(--input-text);
  opacity: 0.7;
}

input[type='date'] {
  -webkit-appearance: none; /* Removes Safari default styling */
  appearance: none;
  display: block;
  width: 100%;
  text-align: left;
}

input[type='date']::-webkit-date-and-time-value {
  text-align: left;
}

input[type='date']:before {
  color: var(--input-text);
  opacity: 0.6;
  content: attr(placeholder) !important;
  height: 1px;
  display: block;
}

input[type='date']:focus:before {
  content: '' !important;
}

.vti__dropdown {
  padding: 0 2px 0 4px !important;
}
.vti__input {
  padding-left: 0 !important;
  outline: none !important;
  color: var(--input-text) !important;
  background-color: transparent !important;
}
.group-field-title-placeholder {
  color: var(--labelColor);
  // max-width: 600px;
}
.general-input {
  cursor: auto;
  position: relative;
  width: 100%;
  padding: 0 10px;
  border: 0;
  outline: none;
  color: var(--input-text);
  background-color: transparent;
  // display: flex;

  &::placeholder {
    color: var(--input-text);
    opacity: 0.7;
  }
}
.isLocked {
  cursor: not-allowed;
}
.special-image-input {
  object-fit: cover;
  height: 100px;
  width: 100px !important;
}
.select-and-placeholder-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  span {
    width: auto;
    color: var(--input-text);
    opacity: 0.7;
    margin-left: 10px;
  }
  option {
    color: var(--input-text);
    background: var(--input-bg);
    color: black;
    background: #eee;
  }
  .is-select {
    color: var(--input-text);
    width: 100%;
    padding: 0 2% 0.3% 0;
    margin: 0 10px 0 6px;
    text-align-last: left;
  }
}

.is-checkbox {
  width: auto;
  margin-left: 4px;
  option {
    float: right;
    text-align: right;
  }
}
.checkbox-span {
  color: var(--input-text);
  opacity: 0.7;
}
.bottom-terms {
  padding-top: 3%;
}
.register-term {
  position: relative;
  max-width: 700px;
  padding: 1% 0;
}
.register-term-text {
  color: var(--input-text);
  a {
    color: var(--input-text);
    opacity: 0.7;
    text-decoration: underline;
  }
}
.bottom-route {
  margin-top: 2%;
  text-decoration: underline;
  color: var(--input-text);
}
@include media('<=phone-plus') {
  .register-second-container {
    margin: 6%;
    min-width: var(--minWidth) !important;
    width: 94%;
  }
  .loginReg-container {
    display: flex;
    flex-direction: column;
  }
  .inputs-line-container {
    flex-wrap: wrap;
    width: 100%;
  }
  .general-input-container {
    padding-right: 0;
  }
  .input-wrapper {
    width: 100%;
  }
  .register-inputs-wrapper {
    width: 100%;
  }
  .register-title {
    width: 100%;
  }
  #phone {
    max-width: 100%;
  }
}

// MULTISELECT
.multiselect,
.multiselect__tags,
.multiselect__content-wrapper {
  // color: #eee;
  background: none;
  border: none;
}
.multiselect {
  max-width: 600px;
}
.multiselect__tags {
  border: none;
  border-radius: 4px;
}
.multiselect__single {
  background: none;
  padding-left: 0;
  margin: 0 4px !important;
}
.multiselect__content-wrapper {
  background: #eee;
}
.multiselect__input {
  display: none;
}
.multiselect__tag {
  background: none;
  padding-left: 0;
  margin: 0 4px !important;
}
.multiselect__tag span {
  margin: 0 !important;
  color: var(--input-text);
  font-size: 1rem;
  background: none;
}
.multiselect__option {
  margin: 0 !important;
  opacity: 1 !important;
}
.multiselect__option span {
  color: black;
  margin-left: 0;
}
.select-and-placeholder-container span {
  opacity: 1 !important;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #3333;
}

// SEARCHABLE SELECT
.select-and-placeholder-container {
  .search {
    font-size: 1rem !important;
    padding-left: 4px !important;
    padding-right: 26px !important;
  }
  .icon {
    padding-right: 4px !important;
  }
  .default {
    color: var(--input-text) !important;
    background-color: var(--input-bg) !important;
    margin-left: 1px;
  }
  .ui.selection.dropdown {
    border: none;
  }
  .ui.dropdown {
    box-shadow: none !important;
    .menu {
      // min-width: unset !important;
      background-color: var(--input-bg) !important;
      color: var(--input-text) !important;
      border: 1px solid var(--input-text) !important;
      .item {
        padding: 6px !important;
      }
    }
  }
}
</style>
